export enum ActivationCenterResourceType {
  FILLED = 'filled',
  MISSING_DATA = 'missingData',
  NOT_ENABLED = 'notEnabled',
}

export enum ActivationCenterStatuses {
  VERY_LOW_DATA = 'veryLowData',
  LIMITED_DATA = 'limitedData',
  SOME_DATA = 'someData',
  MODERATE_DATA = 'moderateData',
  EXTENSIVE_DATA = 'extensiveData',
  ALMOST_COMPLETED_DATA = 'almostCompletedData',
  COMPLETED_DATA = 'completedData',
}
